import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/arrowLeft.svg';

export const IconArrowLeft = createIconComponent(Icon);
